import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import cns from '../../node_modules/classnames/index.js';
import InfoIcon from '../Icons/InfoesIcon.js';
import ErroreIcon from '../Icons/ErroreIcon.js';
import SuccessoIcon from '../Icons/SuccessoIcon.js';
import Tooltip from '../Tooltip/Tooltip.js';

/**
Il componente è stato pensato per visualizzare informazioni
aggiuntive riguardo ad una limitata funzionalità o sezione di interfaccia.

__DEPRECATO: utilizzare `V2/DrawAttention`__
 */
function InfoTooltip({ children, left = false, right = false, top = false, type = 'info', className, }) {
    const Icon = useMemo(() => {
        if (type === 'alarm' || type === 'warning') {
            return ErroreIcon;
        }
        if (type === 'success') {
            return SuccessoIcon;
        }
        return InfoIcon;
    }, [type]);
    const classes = cns('infoTooltip--icon', `infoTooltip--${type}`, className);
    return (jsx(Tooltip, { className: classes, content: children, left: left, right: right, top: top, children: jsx(Icon, { "data-clickable": "false" }) }));
}
InfoTooltip.defaultProps = {
    className: undefined,
    children: undefined,
    left: undefined,
    right: undefined,
    top: undefined,
    type: undefined,
};

export { InfoTooltip as default };
